import Navbar from "@/components/shared/Navbar"
import { DimensionContext } from "@/contexts/Dimension"
import { useUser } from "@/contexts/User"
import { useContext } from "react"
import { Outlet, useLocation } from "react-router"

const Layout = () => {
  const { navbarReference } = useContext(DimensionContext)
  const { user, langLoading, streakData } = useUser()

  const showNavbar = user && langLoading && streakData
  const location = useLocation()
  return (
    <>
      <div
        style={{
          paddingBottom: navbarReference.current?.clientHeight
            ? navbarReference.current?.clientHeight + 20
            : 90,
        }}
        className="scrollbar-thin scrollbar-thumb-modal-color scrollbar-track-background dark:scrollbar-thumb-dark-modal-color dark:scrollbar-track-dark-background overflow-y-auto"
      >
        <Outlet />
      </div>
      {showNavbar && <Navbar ref={navbarReference} />}
    </>
  )
}

export default Layout
